<template>
  <v-main id="mainHome" class="mainHome">
    <v-dialog persistent v-model="cepDialog" max-width="450px">
      <Cep @reaload="reaload"></Cep>
    </v-dialog>
    <div class="max_width_container">
      <!-- CARROSEL DE BANNERS -->
      <v-skeleton-loader
        v-if="loadingBanners"
        type="image"
        :height="isMobile ? 190 : 400"
        class="mb-2 skeleton-banner"
      ></v-skeleton-loader>
      <v-carousel
        v-else
        :height="isMobile ? 190 : 400"
        :show-arrows="false"
        hide-delimiter-background
        show-arrows-on-hover
        eager
        :key="componentKey"
        cycle
        interval="4000"
      >
        <v-carousel-item
          :v-if="banners"
          v-for="(banner, i) in banners"
          target="_blank"
          :key="i"
        >
          <a :href="banner.link" target="_blank">
            <img
              class="carousel-item-img"
              :src="`${isMobile ? banner.imageMobile : banner.image}`"
              alt="Revestimentos adesivos laváveis"
            />
          </a>
        </v-carousel-item>

        <v-carousel-item
          :v-if="!banners"
          v-for="(banner, i) in noBanners"
          :href="banner.link"
          target="_blank"
          :key="i"
          :src="banner.image"
        ></v-carousel-item>
      </v-carousel>

      <v-row cols="12" class="ma-0 cards-destaque" align="center">
        <v-col cols="4" class="container-desktop-itens">
          <div class="d-flex justify-center">
            <v-img
              class="img-width"
              src="../../../assets/revestimento.svg"
              alt="Revestimentos adesivos laváveis"
              contain
            ></v-img>
          </div>

          <div class="revendedor-aplicadores-parceiros">
            <p class="revendedor-aplicadores-parceiros-title">
              Revestimentos e <br />
              adesivos laváveis
            </p>

            <p class="revendedor-aplicadores-parceiros-text">
              Escolha ideal para <br />
              envelopamentos
            </p>
          </div>
        </v-col>

        <v-col cols="4" class="container-desktop-itens">
          <div class="d-flex justify-center">
            <v-img
              class="img-width"
              src="../../../assets/caixa.svg"
              alt="Sempre à disposição"
              contain
            ></v-img>
          </div>

          <div class="revendedor-aplicadores-parceiros">
            <p class="revendedor-aplicadores-parceiros-title">
              Sempre à <br />
              disposição
            </p>

            <p class="revendedor-aplicadores-parceiros-text">
              Produtos a pronta <br />
              entrega
            </p>
          </div>
        </v-col>

        <v-col cols="4" class="container-desktop-itens">
          <div class="d-flex justify-center">
            <v-img
              class="img-width"
              src="../../../assets/check-parceiro.svg"
              alt="Parceiros Confiáveis"
              contain
            ></v-img>
          </div>

          <div class="revendedor-aplicadores-parceiros">
            <p class="revendedor-aplicadores-parceiros-title">
              Parceiros <br />
              Confiáveis
            </p>

            <p
              class="revendedor-aplicadores-parceiros-text hidden-cards-mobile"
            >
              Revendedores <br />autorizados
            </p>
          </div>
        </v-col>
      </v-row>

      <v-card elevation="0" class="container-promocoes-lancamentos ma-0 pa-0" v-if="loadingProducts || (products && products.length > 0)">
        <v-row cols="12">
          <v-col cols="6" class="text-left">
            <p
              v-if="category && category.categoryName"
              class="promocoes-lancamentos"
            >
              {{ formatName(category.categoryName) }}
            </p>
          </v-col>
          <v-col cols="6" class="text-right">
            <a :href="generateLinkProducts()" class="ver-produtos"> Ver todos os produtos </a>
          </v-col>
        </v-row>

        <v-row style="position: relative">
          <div v-if="arrowLeftListProductContent" class="arrow-left">
            <v-img
              max-width="80"
              @click="scrollList('list-product-content', -1, $event)"
              src="../../../assets/arrow-right.svg"
              alt="Sempre à disposição"
              contain
            ></v-img>
          </div>

          <div v-if="loadingProducts" class="d-flex flex-nowrap skeleton-list">
            <v-skeleton-loader
              v-for="n in 4"
              :key="n"
              type="image, article"
              class="mx-2 skeleton-product-card"
              width="220"
            ></v-skeleton-loader>
          </div>

          <v-row
            v-else
            cols="12"
            id="list-product-content"
            class="list-product-content ma-0 pa-0"
            @scroll.passive="updateArrows('list-product-content','arrowLeftListProductContent','arrowRightListProductContent')"
          >
            <v-col v-for="item in products" :key="item.productId">
              <ImageCard
                :key="item.productId + page"
                class="image-card-hover"
                :item="item"
                :env_url="env_url"
              />
            </v-col>

          </v-row>

          <div v-if="arrowRightListProductContent && products.length > 0" class="arrow-right">
            <v-img
              max-width="80"
              @click="scrollList('list-product-content', 1, $event)"
              src="../../../assets/arrow-right.svg"
              alt="Sempre à disposição"
              contain
            ></v-img>
          </div>
        </v-row>
      </v-card>

      <v-card elevation="0" class="container-promocoes-lancamentos">
        <v-row cols="12">
          <v-col cols="6" class="text-left">
            <p class="promocoes-lancamentos">As principais categorias</p>
          </v-col>
          <v-col cols="6" class="text-right"> </v-col>
        </v-row>

        <v-row style="position: relative">
          <div
            v-if="arrowLeftCategory"
            class="arrow-left"
            style="display: block"
          >
            <v-img
              max-width="80"
              @click="scrollList('list-categories', -1, $event)"
              src="../../../assets/arrow-right.svg"
              alt="Sempre à disposição"
              contain
            ></v-img>
          </div>

          <div v-if="loadingCategories" class="d-flex flex-nowrap skeleton-list">
            <v-skeleton-loader
              v-for="n in 6"
              :key="n"
              type="avatar, text"
              class="mx-3 skeleton-avatar"
            ></v-skeleton-loader>
          </div>

          <v-row
            v-else
            cols="12"
            class="flex-nowrap categories"
            id="list-categories"
            @scroll.passive="updateArrows('list-categories','arrowLeftCategory','arrowRightCategory')"
          >
            <v-col v-for="item in categories" :key="item.categoryId">
              <a style="text-decoration: none" :href="generateLinkCategory(item.categoryName)">
                <div class="category-clicle">
                  <v-img
                    v-if="item.pathImage"
                    style="
                      width: 120px;
                      height: 120px;
                      border-radius: 50%;
                      display: flex;
                      margin: 7px 0 0 0;
                    "
                    :src="item.pathImage"
                    :alt="item.categoryName"
                  ></v-img>

                  <v-img
                    v-else
                    style="
                      width: 120px;
                      height: 120px;
                      border-radius: 50%;
                      display: flex;
                      margin: 7px 0 0 0;
                    "
                    src="../../../assets/categoria.svg"
                    :alt="item.categoryName"
                  ></v-img>
                </div>
                <p class="mt-2 categoryName text-center">
                  {{ item.categoryName }}
                </p>
              </a>
            </v-col>
          </v-row>

          <div
            v-if="!loadingCategories && arrowRightCategory"
            class="arrow-right"
            style="display: block"
          >
            <v-img
              max-width="80"
              @click="scrollList('list-categories', 1, $event)"
              src="../../../assets/arrow-right.svg"
              alt="Sempre à disposição"
              contain
            ></v-img>
          </div>
        </v-row>
      </v-card>

      <v-row cols="12">
        <v-col cols="12" class="d-flex justify-center">
          <v-skeleton-loader
            v-if="loadingBanners"
            type="image"
            :height="isMobile ? 190 : 400"
            class="skeleton-banner"
          ></v-skeleton-loader>
          <img
            v-else-if="bannersSecondary"
            class="carousel-item-img"
            :src="`${isMobile ? bannersSecondary.imageMobile : bannersSecondary.image}`"
            :alt="bannersSecondary.title"
          />
          <img
            v-else
            class="carousel-item-img"
            v-bind:src="
              require(`../../../assets/${
                isMobile ? 'bannerSecundaryMobile' : 'bannerSecundary'
              }.png`)
            "
            alt="Imprimax"
          />
        </v-col>
      </v-row>

      <v-card elevation="0" v-if="loadingBestSellers || (productsBestSellers && productsBestSellers.length > 0)" class="container-promocoes-lancamentos">
        <v-row cols="12">
          <v-col cols="6" class="text-left">
            <p class="promocoes-lancamentos">Os mais vendidos</p>
          </v-col>
          <v-col cols="6" class="text-right">
            <a :href="generateLinkProducts()" class="ver-produtos"> Ver todos os produtos </a>
          </v-col>
        </v-row>

        <v-row style="position: relative">
          <div v-if="arrowLeftMaisVendidos" class="arrow-left">
            <v-img
              max-width="80"
              @click="scrollList('maisVendidos', -1, $event)"
              src="../../../assets/arrow-right.svg"
              alt="Sempre à disposição"
              contain
            ></v-img>
          </div>

          <div v-if="loadingBestSellers" class="d-flex flex-nowrap skeleton-list">
            <v-skeleton-loader
              v-for="n in 4"
              :key="n"
              type="image, article"
              class="mx-2 skeleton-product-card"
              width="220"
            ></v-skeleton-loader>
          </div>

          <v-row
            v-else
            cols="12"
            id="maisVendidos"
            class="list-product-content ma-0 pa-0"
            @scroll.passive="updateArrows('maisVendidos','arrowLeftMaisVendidos','arrowRightMaisVendidos')"
          >
            <v-col
              v-for="item in productsBestSellers"
              :key="`maisVendidos${item.productId}`"
            >
              <ImageCard
                :key="`maisVendidos${item.productId}`"
                class="image-card-hover"
                :item="item"
                :env_url="env_url"
              />
            </v-col>
          </v-row>

          <div v-if="!loadingBestSellers && arrowRightMaisVendidos" class="arrow-right">
            <v-img
              max-width="80"
              @click="scrollList('maisVendidos', 1, $event)"
              src="../../../assets/arrow-right.svg"
              alt="Sempre à disposição"
              contain
            ></v-img>
          </div>
        </v-row>
      </v-card>



      <v-card elevation="0" class="container-promocoes-lancamentos" v-if="loadingStores || (resalesDistance && resalesDistance.length > 0)">
        <v-row cols="12">
          <v-col cols="6" class="text-left">
            <p class="promocoes-lancamentos">Lojas oficias</p>
          </v-col>
          <v-col cols="6" class="text-right"> </v-col>
        </v-row>

        <v-row style="position: relative">
          <div
              v-if="arrowLeftResalesDistance"
              class="arrow-left"
              style="display: block"
          >
            <v-img
                max-width="80"
                @click="scrollList('list-resale-distance', -1, $event)"
                src="../../../assets/arrow-right.svg"
                alt="Sempre à disposição"
                contain
            ></v-img>
          </div>

          <div v-if="loadingStores" class="d-flex flex-nowrap skeleton-list">
            <v-skeleton-loader
              v-for="n in 6"
              :key="n"
              type="avatar, text"
              class="mx-3 skeleton-avatar"
            ></v-skeleton-loader>
          </div>

          <v-row
            v-else
            cols="12"
            class="flex-nowrap categories"
            id="list-resale-distance"
            @scroll.passive="updateArrows('list-resale-distance','arrowLeftResalesDistance','arrowRightResalesDistance')"
          >
            <v-col v-for="resale in resalesDistance" :key="resale.categoryId">
              <a style="text-decoration: none!important;" :href="generateLinkVitrine(resale.urlStoreResale)">
                <div class="category-clicle">
                  <v-img
                      v-if="resale.image"
                      style="
                      width: 120px;
                      height: 120px;
                      border-radius: 50%;
                      display: flex;
                      margin: 7px 0 0 0;
                    "
                      :src="resale.image"
                      :alt="resale.categoryName"
                      contain
                  ></v-img>

                  <v-img
                      v-else
                      style="
                      width: 120px;
                      height: 120px;
                      border-radius: 50%;
                      display: flex;
                      margin: 7px 0 0 0;

                    "
                      src="../../../assets/imprimax_logo.png"
                      :alt="resale.nameFantasy"
                      contain
                  ></v-img>
                </div>
                <p class="mt-2 categoryName text-center">
                  {{ resale.nameFantasy }}
                </p>
                <p class="mt-2 categoryName text-center">
                  <span v-if="resale && resale.distance">{{resale.distance.toFixed(2)}} KM de Você</span>
                </p>
              </a>
            </v-col>
          </v-row>

          <div
              v-if="!loadingStores && arrowRightResalesDistance"
              class="arrow-right"
              style="display: block"
          >
            <v-img
                max-width="80"
                @click="scrollList('list-resale-distance', 1, $event)"
                src="../../../assets/arrow-right.svg"
                alt="Sempre à disposição"
                contain
            ></v-img>
          </div>
        </v-row>
      </v-card>
    </div>
  </v-main>
</template>

<style scoped>
.carousel-item-img {
  border-radius: 8px;
  width: 100%;
  height: 400px !important;
}

.max_width_container {
  width: 90% !important;
  margin: 0 5% 0 5%;
}

.container-desktop {
  margin: 20px 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
}

.container-desktop-itens {
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-width {
  max-width: 100px;
}

@media screen and (max-width: 885px) {
  .container-desktop {
    display: flex;
    flex-direction: row;
  }

  .container-desktop-itens {
    display: block;
    align-items: center;
  }

  .revendedor-aplicadores-parceiros-text {
    text-align: center !important;
    font-size: 12px !important;
  }

  .revendedor-aplicadores-parceiros-title {
    text-align: center !important;
    font-size: 13px !important;
  }

  .img-width {
    max-width: 60px;
  }

  .max_width_container {
    width: 100% !important;
    margin: 0 !important;
  }
}


@media screen and (max-width: 600px) {
  /* Banner mais baixo no celular */
  .carousel-item-img {
    height: 190px !important;
    border-radius: 6px;
  }

  .skeleton-banner >>> .v-skeleton-loader__image {
    height: 190px;
  }

  /* Menos padding nas seções e títulos menores */
  .container-promocoes-lancamentos {
    padding: 10px !important;
  }

  .promocoes-lancamentos {
    font-size: 16px;
    line-height: 22px;
  }

  .ver-produtos {
    font-size: 13px;
  }

  /* Círculos de categoria/lojas menores para caber mais na tela */
  .category-clicle {
    width: 104px;
    height: 104px;
    border-width: 5px;
  }

  .categoryName {
    font-size: 13px;
    line-height: 18px;
  }

  /* Cards de destaque (Revestimentos / Sempre à disposição / Parceiros) */
  .cards-destaque {
    align-items: flex-start !important;
  }

  .revendedor-aplicadores-parceiros {
    padding-left: 0;
    text-align: center;
  }

  /* Ignora as quebras de linha forçadas: o texto quebra sozinho */
  .revendedor-aplicadores-parceiros-title br,
  .revendedor-aplicadores-parceiros-text br {
    display: none;
  }

  .revendedor-aplicadores-parceiros-title {
    text-align: center !important;
    min-height: 52px;
  }
}

.container-promocoes-lancamentos {
  box-shadow: 0 72px 132px 0 #051d3d0f !important;
  padding: 10px 20px !important;
}

.promocoes-lancamentos {
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.15000000596046448px;
  color: #2d3038;
  position: relative;
}

.ver-produtos {
  font-size: 15px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: left;
  color: #bc0000;
  text-decoration: none;
}

.image-card-hover:hover {
  box-shadow: 10px 11px 13px rgba(0, 0, 0, 0.25) !important;
}

.list-product-content {
  flex-wrap: nowrap !important;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
  z-index: 0;
}

.list-product-content::-webkit-scrollbar,
.categories::-webkit-scrollbar {
  display: none; /* Chrome/Safari */
}

.arrow-left {
  position: absolute;
  cursor: pointer;
  top: 45%;
  z-index: 1;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
}

.arrow-right {
  position: absolute;
  cursor: pointer;
  top: 50%;
  z-index: 1;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
}

.arrow-left {
  left: 0;
}

.arrow-right {
  right: 0;
}

/* Rotaciona apenas a imagem (seta apontando para a esquerda) */
.arrow-left .v-image {
  transform: rotate(180deg);
}

.revendedor-aplicadores-parceiros {
  text-align: left;
  padding-left: 15px;
}

.revendedor-aplicadores-parceiros-title {
  font-size: 16px;
  font-weight: 700;
  line-height: 23px;
  text-align: left;
  margin: 0;
  padding: 5px 0;
  color: #4f4f4f;
}

.revendedor-aplicadores-parceiros-text {
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  color: #6d7989;
}

.categories {
  flex-wrap: nowrap !important;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
  z-index: 0;
}

.category-clicle {
  border: 8px solid transparent;
  background-image: linear-gradient(white, white),
    linear-gradient(180deg, #ff0000 0%, #9b0707 48.96%, #3f0909 100%);
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background-origin: border-box;
  background-clip: content-box, border-box;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Imagem preenche o círculo (sobrescreve a regra global .v-image__image) */
.category-clicle .v-image {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  border-radius: 50%;
}

.category-clicle >>> .v-image__image {
  height: 100% !important;
  max-height: none !important;
}

.categoryName {
  font-size: 16px;
  font-weight: 600;
  line-height: 23px;
  letter-spacing: 0.15000000596046448px;
  text-align: center;
  color: #4f4f4f;
  text-decoration: none!important;
}

.v-image__image {
  max-height: 270px !important;
  height: 60% !important;
}

.v-item-group {
  height: 320px !important;
}

.transparent-background {
  background-color: transparent;
}

.v-card__title {
  padding: 0px;
  font-family: Poppins;
  width: max-content;
  color: #bc0000;
  font-style: normal;
  font-weight: bold;
  line-height: 27px;
}

.v-card__text {
  padding: 0px;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.15px;
}

.containerList {
  justify-content: center !important;
  flex-direction: column;
}

.mainHome {
  width: 100%;
  padding-top: 0px !important;
  max-width: unset !important;
  text-align: -webkit-center;
  background-color: #f5f5f5;
}

.banner-text {
  text-align: center;
  color: #ffffff;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.15px;
}

.banner-text-destac {
  color: #fede04;
}

/* Skeletons de carregamento por seção */
.skeleton-banner {
  width: 100%;
}

.skeleton-banner >>> .v-skeleton-loader__image {
  height: 400px;
  border-radius: 8px;
}

.skeleton-list {
  width: 100%;
  overflow: hidden;
}

.skeleton-product-card {
  flex: 0 0 auto;
}

.skeleton-avatar {
  flex: 0 0 auto;
  text-align: -webkit-center;
}

.skeleton-avatar >>> .v-skeleton-loader__avatar {
  width: 120px;
  height: 120px;
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import FormatParamsUrl from "../../../Utils/FormatParamsUrl";
import ImageCard from "../components/ImageCard.vue";
import Cep from "../components/Cep.vue";

export default {
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    document.title = 'Loja imprimax'
  },

  data: () => ({
    page: 1,
    loadingBanners: true,
    loadingProducts: true,
    loadingCategories: true,
    loadingBestSellers: true,
    loadingStores: true,
    arrowRightListProductContent: true,
    arrowLeftListProductContent: false,
    arrowRightMaisVendidos: true,
    arrowLeftMaisVendidos: false,
    arrowRightCategory: true,
    arrowLeftCategory: false,
    arrowRightResalesDistance: true,
    arrowLeftResalesDistance: false,
    resalesDistance: [],
    fullAddress: Object,
    cepDialog: false,
    totalPages: 15,
    banners: [],
    bannersSecondary: null,
    noBanners: [],
    componentKey: 1,
    isMobile: false,
    products: [],
    productsBestSellers: [],
    categories: [],
    env_url: "",
    boxNotification: "",
    category: "",
    apiService: new ApiService(),
    baseUrl: null,
    filter: {
      page: 1,
      pageSize: 20,
      bestSellers: true,
    },
    categoryFilter: {
      page: 1,
      pageSize: 20,
      categoryShowHomepage: 0,
    },
  }),

  components: {
    Cep,
    ImageCard,
  },

  computed: {},

  async created() {
    this.baseUrl = window.location.origin
    this.env_url = process.env.VUE_APP_BASE_URL;
    this.cepDialog = this.checkUserFilledZipCode()
    await this.bringBanners();
    await this.getCategories();
    await this.productsByCategory();
    await this.topSellingProducts();
    await this.getOfficialStores();
    this.$nextTick(() => this.updateAllArrows());
  },
  methods: {
    checkUserFilledZipCode(){
      this.cepDialog = false
      let address = localStorage.getItem("address_cep");
      if(!address){
        return true;
      }
      address = JSON.parse(address)
      this.fullAddress = address
      const {cep, latitude, longitude} = address
      return !cep || !latitude || !longitude;
    },
    async reaload() {
      this.cepDialog = false;
      window.location.reload();
    },
    toCategory(category) {
      let cat = category.replace(/ /g, "-").toLowerCase();
      this.$router.push(`/categoria/${cat}`)
    },

    formatName(productName) {
      return (
        productName[0].toUpperCase() + productName.substring(1).toLowerCase()
      );
    },

    async goToVitrine(path) {
      await this.$router.push({path: `/vitrine/${path}`});
    },

    async getCategories() {
      try {
        await this.apiService
          .post(`category/menuActive`, this.filter, null, true, false)
          .then((response) => {
            this.categories = response.categories;
          })
          .catch((err) => {});
      } finally {
        this.loadingCategories = false;
      }
    },

    scrollLists() {
      return [
        { id: "list-product-content", left: "arrowLeftListProductContent", right: "arrowRightListProductContent" },
        { id: "maisVendidos",         left: "arrowLeftMaisVendidos",       right: "arrowRightMaisVendidos" },
        { id: "list-categories",      left: "arrowLeftCategory",           right: "arrowRightCategory" },
        { id: "list-resale-distance", left: "arrowLeftResalesDistance",    right: "arrowRightResalesDistance" },
      ];
    },

    // Clique nas setas: rola ~uma "página" com animação suave.
    // NÃO lê scrollLeft aqui — quem atualiza as setas é o @scroll.
    scrollList(id, direcao, event) {
      if (event) event.preventDefault();
      const el = document.getElementById(id);
      if (!el) return;
      const amount = Math.max(el.clientWidth * 0.9, 200);
      el.scrollBy({ left: amount * direcao, behavior: "smooth" });
    },

    // Recalcula visibilidade das setas a partir da posição real de scroll (com tolerância).
    updateArrows(id, leftKey, rightKey) {
      const el = document.getElementById(id);
      if (!el) return;
      const maxScroll = el.scrollWidth - el.clientWidth;
      const tolerance = 2;
      const hasOverflow = maxScroll > tolerance;
      this[leftKey] = hasOverflow && el.scrollLeft > tolerance;
      this[rightKey] = hasOverflow && el.scrollLeft < maxScroll - tolerance;
    },

    updateAllArrows() {
      this.scrollLists().forEach(({ id, left, right }) =>
        this.updateArrows(id, left, right)
      );
    },

    async bringBanners() {
      try {
        await this.apiService
          .post(`marketing/listActive-banners`, this.filter, null, true, false)
          .then((response) => {
            this.banners = response.banners.filter((banner) => !banner.secondary);
            this.bannersSecondary = response.banners.find(
              (banner) => banner.secondary
            );

            if (this.banners.length <= 0) {
              this.noBanners = [
                {
                  image:
                    "https://lirp.cdn-website.com/193db0b2/dms3rep/multi/opt/gold-couros-1920w.jpg",
                  link: "www.google.com",
                },
                {
                  image:
                    "https://lirp.cdn-website.com/193db0b2/dms3rep/multi/opt/3d-opaco-1920w.jpg",
                  link: "www.google.com",
                },
              ];
            }

            this.componentKey++;
          });
      } finally {
        this.loadingBanners = false;
      }
    },

    async getOfficialStores() {
      try {
        await this.apiService
            .post(`resale/distance`, this.fullAddress, null, true, false)
            .then((response) => {
               this.resalesDistance = response
            });
      } catch (e) {

      } finally {
        this.loadingStores = false;
      }
    },

    onResize() {
      this.isMobile = window.innerWidth < 600;
      this.$nextTick(() => this.updateAllArrows());
    },

    async productsByCategory() {
      try {
        this.category = this.categories.find((x) => x.showHomepage);
        if (!this.category) {
          this.category = this.categories[0];
        }
        this.categoryFilter.categoryShowHomepage = this.category.categoryId;
        await this.apiService
          .post(`product/listActiveB2C`, this.categoryFilter, null, true, false)
          .then((response) => {
            this.products = response.products;
          });
      } catch (e) {
      } finally {
        this.loadingProducts = false;
      }
    },

    async topSellingProducts() {
      try {
        await this.apiService
          .post(`product/listActiveB2C`, this.filter, null, false, false)
          .then((response) => {
            this.productsBestSellers = response.products;
          }).catch((error) => {
          });
      } catch (e) {
      } finally {
        this.loadingBestSellers = false;
      }
    },

    async saveSearch() {
      await this.apiService.post("search", {
        searchedText: this.filter.product,
      });
    },

    async goTo(item) {
      const param = FormatParamsUrl.format(item.productName);
      await this.$router.push({
        path: `/produtos/${param}`,
        params: item,
      });
    },

    async to(path) {
      await this.$router.push({ path: `/${path}`});
    },

    generateLinkProducts(){
      return `${this.baseUrl}/produtos`
    },
    generateLinkCategory(categoryName){
      return `${this.baseUrl}/categoria/${categoryName.replace(/ /g, "-").toLowerCase()}`
    },
    generateLinkVitrine(urlStoreResale){
      return `${this.baseUrl}/vitrine/${urlStoreResale}`
    },
  },
};
</script>
